/**
 * @copyright © Paramount Streaming
 * @author Stan Gletski
 * @description Event dispatch priority... The higher the priority the earlier event should be dispatched
 */
export enum EventPriority {
	// The highest priority :)
	PROPANE = '0000_PROPANE',
	HIGH = '0001_HIGH',
	NORMAL = '0002_NORMAL',
	LOW = '0003_LOW',
	PTO = '0004_PTO'
}